import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/app/components/shadcn/tooltip";
import { Info, Truck } from "lucide-react";
import FallbackImage from "@/app/components/elements/FallbackImage";
import useProductDetail from "@/app/lib/features/productDetail/productDetail.hook";

const DeliveryInfo = () => {
  const { product } = useProductDetail();

  if (!product?.shipping) return null;

  const { shipping } = product;

  return (
    <div 
      className="p-2 rounded-xl"
      style={{ 
        backgroundColor: shipping.background_color_hex || '#effbf5'
      }}
    >
      {/* Fast Shipping Header */}
      {shipping.head_title && (
        <>
          <div className="flex items-start sm:items-center gap-2 sm:gap-3 text-[11px] font-medium py-1">
            <Truck size={16} className="text-green-500 shrink-0 mt-0.5 sm:mt-0" />
            <p dangerouslySetInnerHTML={{ __html: shipping.head_title }} />
          </div>
          <div className="mx-4">
            <div className="bg-[#ccc] w-full h-px" />
          </div>
        </>
      )}

      {/* Delivery Info */}
      <div className="flex items-start sm:items-center gap-2 text-[11px] font-medium py-1">
        {shipping.company_logo && (
          <FallbackImage
            src={shipping.company_logo}
            alt={shipping.company_name || "Kargo"}
            width={40}
            height={30}
            className="rounded-sm bg-white border shrink-0"
          />
        )}
        <div>
          <div className="flex items-center gap-2">
            <span className="font-bold">{shipping.title || "Tahmini Teslim:"}</span>
            {shipping.info && (
              <Tooltip>
                <TooltipTrigger>
                  <Info
                    size={10}
                    className="text-black cursor-pointer transition-all duration-300 ease-in-out hover:text-main"
                  />
                </TooltipTrigger>
                <TooltipContent className="w-[320px] sm:w-122.5" variant="white">
                  <p className="text-xs">{shipping.info}</p>
                </TooltipContent>
              </Tooltip>
            )}
          </div>
          {shipping.sub_title && <p>{shipping.sub_title}</p>}
        </div>
      </div>
    </div>
  );
};

export default DeliveryInfo;
